import React from "react";
import "./styles.scss";

function ProgramBrief() {
  // const handleClick = () => {
  //   const element = document.getElementById("overview");

  //   if (element) {
  //     element.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //       inline: "nearest",
  //     });
  //   }
  // };

  return (
    <div className="overview-container-mlp">
      <div className="program-brief-into-section-desk mt-0">
        <div className="flex-item">
          <img
            className="item-img-mlp"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21fhk9w.webp"
            alt="Sand glass timer"
          />
          <div className="item-header">Course Duration</div>
          <div className="item-desc">19 weeks</div>
        </div>
        <div className="vertical-divider-mlp" />
        <div className="flex-item">
          <img
            className="item-img-mlp"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86yzpcm2aetc4s.webp"
            alt="Clock"
          />
          <div className="item-header">Timing</div>
          <div className="item-desc">Weekdays 10 AM - 8 PM</div>
        </div>
        <div className="vertical-divider-mlp" />
        <div className="flex-item">
          <img
            className="item-img"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m20bu0ba.webp"
            alt="Calendar"
          />
          <div className="item-header">Batch Starts</div>
          <div className="item-desc">May 15, 2025</div>
        </div>
        <div className="vertical-divider-mlp" />
        <div className="flex-item">
          <img
            className="item-img-mlp"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21eyufa.png"
            alt="Bag"
          />
          <div className="item-header">Program Outcomes</div>
          <div className="item-desc" style={{ marginTop: "-0.5rem" }}>
            ₹4.5 - 9.2L Jobs + <br />
            INDUSTRYCreds<sup>®</sup> Certification
          </div>
        </div>
      </div>
      <div className="program-brief-into-section-mob ">
        <div className="flex-item">
          <img
            className="item-img-mlp"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21fhk9w.webp"
            alt="Sand glass timer"
          />
          <div className="item-header">Course Duration</div>
          <div className="item-desc">19 weeks</div>
        </div>
        <div className="flex-item">
          <img
            className="item-img"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m20bu0ba.webp"
            alt="Calendar"
          />
          <div className="item-header">Batch Starts</div>
          <div className="item-desc">May 15, 2025</div>
        </div>
        <div className="horizontal-divider" />
        <div className="flex-item">
          <img
            className="item-img-mlp"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21eyufa.png"
            alt="Bag"
          />
          <div className="item-header">Program Outcomes</div>
          <div className="item-desc">
            ₹4.5 - 9L Jobs + <br />
            <span className="INDUSTRY-cred-mob">
              INDUSTRY Creds<sup>®</sup> Certification
            </span>
          </div>
        </div>
        <div className="flex-item">
          <img
            className="item-img-mlp"
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86yzpcm2aetc4s.webp"
            alt="Clock"
          />
          <div className="item-header">Timing</div>
          <div className="item-desc">
            Weekdays -<br /> 10 AM - 8 PM
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProgramBrief;
